import { useCallback } from "react";
import useSWR, { useSWRConfig, type SWRConfiguration, type SWRResponse } from "swr";

export interface ResourceRef {
  type: string;
  id: string;
}

const RESOURCE_QUERY_NAMESPACE = "resource";

function isQueryKeyOfResource(key: unknown, resource: ResourceRef): boolean {
  return (
    Array.isArray(key) &&
    key[0] === RESOURCE_QUERY_NAMESPACE &&
    key[1] === resource.type &&
    key[2] === resource.id
  );
}

export function useResourceQuery<Data>(
  resource: ResourceRef | null,
  view: string,
  fetchView: (resource: ResourceRef) => Promise<Data>,
  config?: SWRConfiguration<Data>,
): SWRResponse<Data> {
  return useSWR(
    resource ? [RESOURCE_QUERY_NAMESPACE, resource.type, resource.id, view] : null,
    ([, resourceType, resourceId]: string[]) => fetchView({ type: resourceType, id: resourceId }),
    config,
  );
}

export function useAnnounceResourceChanged(): (resource: ResourceRef) => Promise<unknown[]> {
  const { mutate } = useSWRConfig();
  return useCallback(
    (resource: ResourceRef) => mutate((key) => isQueryKeyOfResource(key, resource)),
    [mutate],
  );
}
